import type * as lazyFunctions from './lazyFunctions';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "AppBootDataWorker" */ './lazyFunctions'),
    { name: 'AppBootDataWorker' }
);

// precompile schema intentionally exported non-lazy to ensure it's included in the main bundle and can kick off as early as possible
export { precompileSchema } from './actions/precompileSchema';
export { applyTombstonesToSessionData } from './actions/applyTombstonesToSessionData';
export { getOfflineSessionData } from './actions/getOfflineSessionData';
export { initializeOfflineTimezoneData } from './actions/getOfflineTimeZones';

export const lazyExecuteRequest: LazyAction<
    typeof lazyFunctions.lazyExecuteRequest.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyExecuteRequest.importAndExecute);
export const lazyUnsubscribe: LazyAction<
    typeof lazyFunctions.lazyUnsubscribe.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyUnsubscribe.importAndExecute);
export const lazySetDisableAllRequests: LazyAction<
    typeof lazyFunctions.lazySetDisableAllRequests.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySetDisableAllRequests.importAndExecute);
export const lazyFlushSyncLogs: LazyAction<
    typeof lazyFunctions.lazyFlushSyncLogs.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyFlushSyncLogs.importAndExecute);
export const lazyOnManualSyncMail: LazyAction<
    typeof lazyFunctions.lazyOnManualSyncMail.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyOnManualSyncMail.importAndExecute);
export const lazySaveOfflineSessionData: LazyAction<
    typeof lazyFunctions.lazySaveOfflineSessionData.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySaveOfflineSessionData.importAndExecute);
export const lazyGetOfflineTimeZones: LazyAction<
    typeof lazyFunctions.lazyGetOfflineTimeZones.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetOfflineTimeZones.importAndExecute);
export const lazyGetOfflineTimeZoneOffsets: LazyAction<
    typeof lazyFunctions.lazyGetOfflineTimeZoneOffsets.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetOfflineTimeZoneOffsets.importAndExecute);
export const lazyScheduleHierarchySync: LazyAction<
    typeof lazyFunctions.lazyScheduleHierarchySync.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyScheduleHierarchySync.importAndExecute);
export const lazyOnManualSyncPGAL: LazyAction<
    typeof lazyFunctions.lazyOnManualSyncPGAL.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyOnManualSyncPGAL.importAndExecute);
export const lazyOnManualSyncCalendar: LazyAction<
    typeof lazyFunctions.lazyOnManualSyncCalendar.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyOnManualSyncCalendar.importAndExecute);
export const lazySetAccountTimeZone: LazyAction<
    typeof lazyFunctions.lazySetAccountTimeZone.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySetAccountTimeZone.importAndExecute);
export const lazyNotifyWorkerLocaleChanged: LazyAction<
    typeof lazyFunctions.lazyNotifyWorkerLocaleChanged.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyNotifyWorkerLocaleChanged.importAndExecute);
export const lazyLoadOfflineSettings: LazyAction<
    typeof lazyFunctions.lazyLoadOfflineSettings.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyLoadOfflineSettings.importAndExecute);
export const lazySaveOfflineSettings: LazyAction<
    typeof lazyFunctions.lazySaveOfflineSettings.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazySaveOfflineSettings.importAndExecute);
export const lazyInvalidateOfflineConversationNodes: LazyAction<
    typeof lazyFunctions.lazyInvalidateOfflineConversationNodes.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyInvalidateOfflineConversationNodes.importAndExecute);
export const lazyLogPeopleDataToSyncLogs: LazyAction<
    typeof lazyFunctions.lazyLogPeopleDataToSyncLogs.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyLogPeopleDataToSyncLogs.importAndExecute);

export const lazyLoadPeopleAppData: LazyAction<
    typeof lazyFunctions.lazyLoadPeopleAppData.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyLoadPeopleAppData.importAndExecute);
